import axios from "axios";
import { BaseResponse } from "../models/base";
import {
  IndustryItem,
  JobLevelItem,
  SkillItem,
  CurrencyItem,
  StateItem,
  Company,
  UserDashboardData,
  CountryItem,
  LanguageItem,
  CityItem,
  WorkTypeItem,
  WorkplaceItem,
  QualificationTypeItem,
} from "../models/master";

export const getIndustriesApi = async (): Promise<
  BaseResponse<IndustryItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/industries`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getJobLevelsApi = async (): Promise<
  BaseResponse<JobLevelItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/job-levels`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getSkillsApi = async (): Promise<
  BaseResponse<SkillItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/skills`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getCurrenciesApi = async (): Promise<
  BaseResponse<CurrencyItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/currencies`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getWorkTypesApi = async (): Promise<
  BaseResponse<WorkTypeItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/work-types`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during work types fetch:", error);
  }
};

export const getWorkPlacesApi = async (): Promise<
  BaseResponse<WorkplaceItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/work-place`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during work places fetch:", error);
  }
};

export const getQualificationTypesApi = async (): Promise<
  BaseResponse<QualificationTypeItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/qualification-types`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during qualification types fetch:", error);
  }
};

export const uploadToS3 = async (
  s3Url: string,
  formData: FormData
): Promise<any> => {
  try {
    const response = await axios.post(`${s3Url}`, formData, {
      headers: {},
    });


    return response?.status;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getStatesApi = async (): Promise<
  BaseResponse<StateItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/states`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getCitiesApi = async (
  stateId: string
): Promise<BaseResponse<CityItem[]> | undefined> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/cities?stateId=${stateId}`
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getCountriesApi = async (isMiddleEastCountry: boolean = false): Promise<
  BaseResponse<CountryItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/countries?isMiddleEastCountry=${isMiddleEastCountry}`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getLanguagesApi = async (): Promise<
  BaseResponse<LanguageItem[]> | undefined
> => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_BASE_URL}/master/languages`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const addSkillsApi = async (
  passedSkill: string
): Promise<BaseResponse<SkillItem> | undefined> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/master/insert/skills`,
      {
        skillId: null,
        skillName: passedSkill,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during company name change:", error);
  }
};

export const getStatsData = async (): Promise<
  BaseResponse<UserDashboardData> | undefined
> => {
  try {
    const response = await axios.get(
      `${
        import.meta.env.VITE_BASE_URL
      }/clients/company/profile/get/${localStorage.getItem(
        "companyId"
      )}/dashboardInfo`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during dashboard info:", error);
  }
};

export const companyNameApi = async (): Promise<
  BaseResponse<Company> | undefined
> => {
  try {
    const response = await axios.get(
      `${
        import.meta.env.VITE_BASE_URL
      }/clients/company/profile/get/${localStorage.getItem("companyId")}`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error during login:", error);
  }
};
